import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { environment } from 'src/environments/environment';
const { API_URL } = environment;
@Component({
  selector: 'app-mismatchreport',
  templateUrl: './mismatchreport.component.html',
  styleUrls: ['./mismatchreport.component.scss']

})
export class MismatchreportComponent implements OnInit {
  Resultdata: any;  
  tableSelectedColumn: ColDef[]|any = [];
  panNumber:any
  panStatus:any
 
  public defaultColDef: ColDef|any = {
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true,
    sortable:true,
    
  }
  constructor(private apiHttpService: ApiHttpService) { }

  ngOnInit(): void {
    let merchantdata = { "name": "" }
    this.apiHttpService
      .post(`${API_URL}/GetMerchant`, merchantdata)
      .subscribe((res) => {
        this.Resultdata = res
      });
  }
  
  columnDefs: ColDef[] = [
    { field: 'fieldName', headerName: 'Field Name' },
    { field: 'inputGivenByMerchant' ,headerName: 'Input Provided'},
    { field: 'responseFromAPI',headerName: 'Response' }
];
rowData:any= []



// rowData = [
//     { fieldName: 'Toyota', inputProvided: 'Celica', response: 35000 },
//     { fieldName: 'Ford', inputProvided: 'Mondeo', response: 32000 },
//     { fieldName: 'Porsche', inputProvided: 'Boxster', response: 72000 }
// ];
merchantId:any
alertListDTOs:any=[]
riskScoreDTO:any;
statusDto:any
directorDTOS:any=[]
alertSummaryDTO:any
alertListDTOFinal:any

fetchMisMatchReportList(){
  debugger
  // this.apiHttpService.get(`${API_URL}/passport/verify/list?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), null).subscribe((data: any) => {  
    this.apiHttpService.get(`${API_URL}/mismatch/${this.merchantid}`).subscribe((data: any) => {      
 
    this.rowData=data.comparasionDTOS; 
this.alertListDTOFinal=data.alertDTO.alertListDTOFinal

this.alertSummaryDTO=data.alertDTO.alertSummaryDTO

this.riskScoreDTO=data.riskScoreDTO;
this.statusDto=data.statusDto;

this.directorDTOS=data.statusDto.directorDTOS;


  //alert("this.alertListDTOs====="+JSON.stringify(this.riskScoreDTO));
  
    console.log("MisMtch Report this.alertListDTOs===="+JSON.stringify(this.alertListDTOs))
     })

}
merchantid:any;
  showhtml:boolean=false
  onSelectMerchant(event:any){
  //  this.permissions = this.menuService.getPermissions(this.path);

    if(event==undefined){
      this.showhtml=false
    }
    else{
     
      this.merchantid=event;
      this.showhtml=true
      this.fetchMisMatchReportList();
      
    }
  }



}
